import styled from "styled-components"

export const ColumnContainer = styled.div`
  height: 100%;
  min-width: ${({ widthColumn }) => (widthColumn ? widthColumn : "250px")};
  display: grid;
  grid-template-rows: 100px 1fr;
`

export const ColumnHeaderContainer = styled.div`
  position: sticky;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: #efeded;
  display: flex;
  flex-direction: column;
  justify-content: center;
`

export const ColumnHeader = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 10% 65% 12% 1fr;
  h2 {
    height: 100%;
    width: 100%;
    background-color: white;
    font-size: 1.1rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`

export const ChipsItem = styled.div`
  height: 100%;
  width: 100%;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  p {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: green;
    width: 25px;
    height: 25px;
    border-radius: 50%;
    color: white;
  }
`

export const TriangleStyleOne = styled.div`
  border-bottom: 25px solid transparent;
  border-top: 25px solid transparent;
  border-left: 20px solid #efeded;
  background-color: white;
`

export const TriangleStyleTwo = styled.div`
  border-bottom: 25px solid #efeded;
  border-top: 25px solid #efeded;
  border-left: 20px solid transparent;
  background-color: white;
`

export const ColumnBody = styled.div`
  justify-self: center;
  display: flex;
  flex-direction: column;
  grid-gap: 15px;
  width: 92%;
  padding-bottom: 30px;
`
